import { createApiEffect } from '@/features/api/common/create-api-effect'
import IDeleteResultParams from '@/features/api/results/results-courses-students/types/IDeleteResultParams'

export const deleteResultFx = createApiEffect<
  IDeleteResultParams,
  Blob,
  {
    row_errors: {
      row_number: number
      error_message: string
    }[]
  }
>({
  requestMapper: (params) => {
    return {
      method: 'DELETE',
      url: `/api/results-app/results/courses/${params.course}/${params.lesson}/${params.student}/delete/`,
      body: { groupIds: Array.isArray(params.groupIds) ? params.groupIds.map(Number) : [] },
    }
  },
})
